// extracted by mini-css-extract-plugin
export default {"actions":"voucher-detail-actions_actions__IuvOX"};